import React from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Button, Loading, Pane, PaneFooter } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import RenderFormFields from './RenderFormFields';

function OtherSettingsForm({ initialValues, onHandleSubmit, isLoading }) {
  const renderPaneFooter = (submit, pristine, submitting, form) => {
    return (
      <PaneFooter
        renderEnd={
          <Button
            buttonStyle="primary"
            disabled={pristine || submitting}
            id="templates-other-settings-form-pane-footer-submit-btn"
            marginBottom0
            onClick={(event) => {
              submit(event);
            }}
            onMouseDown={(e) => e.preventDefault()}
          >
            <FormattedMessage
              id="stripes-core.button.save"
              defaultMessage="Save"
            />
          </Button>
        }
        renderStart={
          <Button
            id="templates-other-settings-form-pane-footer-cancel-btn"
            marginBottom0
            onClick={() => form.reset()}
            onMouseDown={(e) => e.preventDefault()}
            disabled={pristine || submitting}
          >
            <FormattedMessage
              id="stripes-components.cancel"
              defaultMessage="Cancel"
            />
          </Button>
        }
      />
    );
  };

  return (
    <Form
      onSubmit={onHandleSubmit}
      initialValues={initialValues}
      mutators={{
        ...arrayMutators,
      }}
    >
      {({ handleSubmit, pristine, submitting, form, values }) => {
        return (
          <Pane
            id="inventory-plugin-template-otherSettings-list-pane"
            paneTitle={
              <FormattedMessage
                id="ui-plugin-inventory-templates.otherSettings.pane.paneTitle"
                defaultMessage="Other settings"
              />
            }
            fluidContentWidth
            centeredContent
            footer={renderPaneFooter(handleSubmit, pristine, submitting, form)}
          >
            <form id="templates-other-settings-form" onSubmit={handleSubmit}>
              {isLoading && <Loading size="large" />}
              {!isLoading && <RenderFormFields />}
              {/* <hr />
              <pre>{JSON.stringify(values, 0, 2)}</pre> */}
            </form>
          </Pane>
        );
      }}
    </Form>
  );
}

OtherSettingsForm.propTypes = {
  onHandleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default OtherSettingsForm;
